export enum SharingType {
  Filter = 1,
  Collection = 2,
  CustomerFavourite = 3,
  QuickSearch = 4,
  SavedSearch = 5,
  ClientRequest = 6,
  Product = 7,
  Task = 0,
  SendMail = 10,
  SendMailAdvance = 11,
}
export default SharingType;
